<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :title="title" :text="text">         
                    <v-form id="form" ref="form">
                        <v-container py-0>
                            <v-layout wrap>
                                <v-flex xs12 md12>
                                    <v-select :readonly="paisReadOnly" :label="cboPais" :items="lista.pais" return-object v-model="paisComputed"
                                        item-value="id" item-text="nome" :no-data-text="cboPaisSemDados" required :rules="rules.pais"></v-select>
                                </v-flex>
                                                                
                                <v-flex xs12 md12>
                                    <range-date-picker v-model="dataSelecionada" :required="true" :requiredText="selecionePeriodo" :label="periodo">
                                    </range-date-picker>
                                </v-flex>     

                                <v-flex xs12 md12 class="d-flex justify-center">
                                    <v-btn class="danger" @click="btnLimpar_OnClick">
                                        <v-icon left>mdi-restore</v-icon> 
                                        {{clear}}
                                    </v-btn>                          

                                    <v-btn class="success" @click="btnPesquisar_OnClick">
                                        <v-icon left>mdi-filter</v-icon> 
                                        {{search}}
                                    </v-btn>                                                                                
                                </v-flex> 
                            </v-layout>
                        </v-container>
                    </v-form>                                                     
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import DatePickerRange from '@/components/material/DatePickerRange'
import PaisApi from '@/api/workspace/corporativo/pais'

import { mapGetters } from 'vuex'

export default {
    mixins: [ FormMixin, DateMixin ],   
    components: {
        "range-date-picker": DatePickerRange
    },    
    data () {
        return {         
            lista: {
                pais: []
            },
            paisReadOnly: false,      
            paisPadraoUsuario: false,     
            dataSelecionada: null,
            pais: null,
            rules:{
                pais: [
                    val => {
                        if((val || null) == null)
                            return this.cboPaisObrigatorio;

                        return true;
                    }
                ]                          
            },             
        }
    },
    computed: {  
        ...mapGetters("app", ["getUserCountry"]),                                                                                                                      
        title () {
            return this.$t('Views.Corporativo.Enquete.Dashboard.form-title')
        },
        text () {
            return this.$t('Views.Corporativo.Enquete.Dashboard.form-text')            
        },        
        periodo(){
            return this.$t('Views.Corporativo.Enquete.Dashboard.periodo')            
        },     
        cboPais(){
            return this.$t('Views.Onboarding.Colaborador.Listar.pais');            
        },
        cboPaisSemDados(){
            return this.$t('Views.Onboarding.Colaborador.Listar.nenhum-pais-encontrado');            
        }, 
        cboPaisObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.Listar.selecione-pais');            
        }, 
        selecionePeriodo(){
            return this.$t('Views.Corporativo.Enquete.Dashboard.selecione-periodo')            
        },
        paisComputed: {
            get(){
                if(this.pais == null && this.getUserCountry != null && !this.paisPadraoUsuario){
                    this.$set(this, "paisPadraoUsuario", true);
                    this.$set(this, "pais", this.getUserCountry);
                }

                return this.pais;
            },
            set(value){
                this.$set(this, "pais", value);
            }
        },                 
    },
    async created(){
        this.formUniqueCode = "FORM.ONCO.00006";
        this.privilegeUniqueCode = "SELC";

        this.$set(this.showItem, "insert", await this.hasAccess(this.formUniqueCode, "SELC"));
    },
    async mounted(){       
        const loading = this.showLoading();
        this.$set(this, "dataSelecionada", this.createPeriodFromNowToPast(15, "days"));

        if(this.pais == null && this.getUserCountry != null && !this.paisPadraoUsuario){
            this.paisPadraoUsuario = true;
            this.$set(this, "pais", this.getUserCountry);
        }

        await this.listarPais();                     
        loading.close();              
    },
    methods:{     
        async listarPais(){
            const pais = await PaisApi.listar().catch(erro => this.showSnackbarError(erro.error));            

            if(pais.success) {
                this.$set(this.lista, "pais", pais.data);
            }
            else {                        
                this.showSnackbarError(pais.error);
                throw new Error(pais.error[0].userMessage);
            }          
        },    
        async btnLimpar_OnClick(){
            this.$set(this, "dataSelecionada", []);
            this.$refs.form.reset();

            if(this.getUserCountry != null){
                this.$nextTick(() => {
                    this.$set(this, "paisPadraoUsuario", false);
                    this.$set(this, "pais", null);
                        
                });
            }         
        },          
        btnPesquisar_OnClick(){
            if(this.$refs.form.validate()){
                const dataInicial = this.$moment(this.dataSelecionada[0]).toDate();
                const dataFinal = this.$moment(this.dataSelecionada[1]).toDate();

                let url = `/onboarding/dashboard/resultado/${this.pais.id}/${this.tranformDate2Epoch(dataInicial)}/${this.tranformDate2Epoch(dataFinal)}`;
                this.$router.push(url);
            }
        }                  
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>
